module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Standard-Regular.7212d44b.ttf";